import React from "react";
import AdminSettings from "../../views/adminView/settings";

export default function AdminSettingsPage() {
  return <AdminSettings />;
}
